import { User } from "@auth0/auth0-react";
import { atom } from "jotai";

export const currentUser = atom<User>({});
